import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function BranchMenu({ styleProps, hoverProps }) {
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            variant="outlined"
            disableRipple
            startIcon={
              <img src={allIcons.homeIcon} alt={"home-icon"} width={20} />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor={appcolors.black}
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            {...bindTrigger(popupState)}
            sx={{
              "& .MuiButton-endIcon": {
                borderLeft: "1px solid #ECF0F2",
              },
              border: "none",
              borderRadius: 0,
              padding: 0,
              color: "#0000008A",
              fontWeight: 400,
              width: "auto",
              height: "auto",
              ...styleProps, // Spread additional style props
              "&:hover": {
                color: "#0000008A",
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                ...hoverProps, // Spread additional hover style props
              },
            }}
          >
            Brnaches
          </Button>
          <Menu {...bindMenu(popupState)}>
            <MenuItem onClick={popupState.close}>Brnache 1</MenuItem>
            <MenuItem onClick={popupState.close}>Brnache 2</MenuItem>
            <MenuItem onClick={popupState.close}>Brnache 3</MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
